import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { chatsSlice } from "../store/chatSlice";
import { useChatsUIContext } from "../context/ChatsContext";
import { ChatMessage } from "../types";

const { actions } = chatsSlice;

export const useChatNavigation = () => {
  const chatsContext = useChatsUIContext();
  const dispatch = useDispatch();

  const chatsUIProps = useMemo(() => {
    return {
      navigatePage: chatsContext?.navigatePage,
      setReplyingTo: chatsContext?.setReplyingTo,
      setNavigatePage: chatsContext?.setNavigatePage,
    };
  }, [
    chatsContext?.navigatePage,
    chatsContext?.setReplyingTo,
    chatsContext?.setNavigatePage,
  ]);

  const backToPrevRoute = useCallback(
    (clearSelectedChat: boolean = true) => {
      const history = chatsUIProps?.navigatePage?.history
        ? [...chatsUIProps.navigatePage.history]
        : [];
      history.pop();

      const key = chatsUIProps?.navigatePage?.key
        ? [...chatsUIProps.navigatePage.key]
        : [];
      key.pop();

      if (history?.length === 0 && clearSelectedChat) {
        dispatch(actions.setEmptyAdjustedMessages());
        dispatch(actions.clearSelectedChat());
      }

      chatsUIProps?.setReplyingTo?.({} as ChatMessage);

      const current = history.length > 0 ? history[history.length - 1] : "home";

      chatsUIProps?.setNavigatePage?.({
        current,
        key,
        history,
      });
    },
    [chatsUIProps, dispatch]
  );

  return {
    backToPrevRoute,
    chatsUIProps,
  };
};
